// extracted by mini-css-extract-plugin
export var features = "Result-module--features--46bc9";
export var image = "Result-module--image--ce66f";